// 9fbef606107a605d69c0edbcd8029e5d
import { SESSIONCONFIG_REDUCER_KEY } from '@tcp/core/src/constants/reducer.constants';
import { createSelector } from 'reselect';
import {
  getShowStoreSpecialsV2,
  getStoreSpecialDiscountDefaultValue,
} from '@tcp/core/src/reduxStore/selectors/session.selectors.js';
import BagPageSelectors from '../../../../features/CnC/BagPage/container/BagPage.selectors';
import { DEFAULT_REDUCER_KEY } from '../../../../../utils/cache.util';
import { getDefaultFavStore } from '../../../../features/account/User/container/User.selectors';
import { getOfferTypeBasedPromotion } from '../../../molecules/PickupBopisPromotionBanner/container/BopisPromotionBanner.selector';

const getPromotions = (state) => {
  return state && state?.Promotions;
};

const getServerTimeFromState = (state) => {
  const { siteOptions } = state[SESSIONCONFIG_REDUCER_KEY];
  return siteOptions && siteOptions.serverTime;
};

const getPromotionsData = (state) => {
  return state && state?.Promotions?.promotionsData;
};

const getPLCCDiscountValue = (state) => {
  const promotionsData = getPromotionsData(state);
  if (!promotionsData) {
    return null;
  }
  const plccOfferData = Object.values(promotionsData)?.find(
    (promotion) => promotion?.offerType === 'PLCC'
  );
  return plccOfferData ? plccOfferData?.discountValue : null;
};

const getAppliedCouponsOnPDP = createSelector(
  getPromotions,
  (promotions) => promotions?.appliedPromotion
);

const getCachedPromotions = createSelector(
  getPromotions,
  (promotions) => promotions?.cachedPromotions
);

const getUpdateCheckbox = createSelector(getPromotions, (promotions) => promotions?.updateCheckbox);

const getMemoisedCouponMap = createSelector(
  BagPageSelectors.getCouponMap,
  (couponMap) => couponMap || null
);

const getRemovedPromotionsOnPdp = createSelector(
  getPromotions,
  (promotions) => promotions?.removedPromotions
);

const getCacheUntilForCart = (state) => {
  return state?.CartPageReducer?.get(DEFAULT_REDUCER_KEY);
};

const getStoreSpecialDiscount = (state) => {
  const promotionsData = getPromotionsData(state);
  if (!promotionsData) {
    return null;
  }
  const storeSpecialOfferData = Object.values(promotionsData)?.find(
    (promotion) => promotion?.promotionId === 'StoreSpecialPromotion'
  );
  return storeSpecialOfferData
    ? {
        discountValue: storeSpecialOfferData?.discountValue,
        endDate: storeSpecialOfferData?.endDate,
        startDate: storeSpecialOfferData?.startDate,
      }
    : null;
};
const getStoreDiscount = createSelector(
  getDefaultFavStore,
  (defaultStore) => defaultStore?.basicInfo?.storeDiscount
);

const getDefaultStoreId = createSelector(
  getDefaultFavStore,
  (defaultStore) => defaultStore?.basicInfo?.id
);

const getStoreSpecialDiscountValue = createSelector(
  getStoreDiscount,
  getOfferTypeBasedPromotion,
  getStoreSpecialDiscountDefaultValue,
  getShowStoreSpecialsV2,
  (storeDiscount, offerBasedPromotions, defaultDiscount, storeSpecialV2Enabled) => {
    if (!storeSpecialV2Enabled && offerBasedPromotions.StoreSpecials_PROMO_DISCOUNT) {
      return offerBasedPromotions.StoreSpecials_PROMO_DISCOUNT;
    }
    if (storeSpecialV2Enabled && storeDiscount) {
      return storeDiscount;
    }
    return defaultDiscount;
  }
);

export {
  getServerTimeFromState,
  getPromotionsData,
  getAppliedCouponsOnPDP,
  getCachedPromotions,
  getUpdateCheckbox,
  getMemoisedCouponMap,
  getRemovedPromotionsOnPdp,
  getCacheUntilForCart,
  getPLCCDiscountValue,
  getStoreSpecialDiscount,
  getStoreSpecialDiscountValue,
  getStoreDiscount,
  getDefaultStoreId,
};
